(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_blog-post-content"] && !Shopify.designMode) return;
  try {
    (() => {
  // Configuration
  const CONFIG = {
    selectors: {
      toc: '[data-article-toc]',
      toggle: '[data-toc-toggle]',
      nav: '[data-toc-nav]',
      list: '[data-toc-list]',
      content: '[data-article-content]'
    },
    classes: {
      initialized: 'is-initialized',
      expanded: 'is-expanded',
      active: 'is-active'
    },
    observerOptions: {
      root: null,
      rootMargin: '-20% 0px -70% 0px',
      threshold: 0
    }
  };

  // DOM Elements
  const toc = document.querySelector(CONFIG.selectors.toc);
  const toggle = document.querySelector(CONFIG.selectors.toggle);
  const list = document.querySelector(CONFIG.selectors.list);
  const content = document.querySelector(CONFIG.selectors.content);

  // Exit if required elements are missing
  if (!toc || !list || !content) return;

  // Extract h2 headings from article content
  const headings = content.querySelectorAll('h2');

  // Exit if no headings found (don't show empty TOC)
  if (headings.length === 0) return;

  // Generate unique ID for headings without one
  const generateId = (text, index) => {
    const slug = text
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
    return slug || `section-${index + 1}`;
  };

  // Ensure all h2s have IDs and build TOC items
  const tocItems = [];

  headings.forEach((heading, index) => {
    // Add ID if missing
    if (!heading.id) {
      heading.id = generateId(heading.textContent, index);
    }

    // Ensure ID is unique
    let uniqueId = heading.id;
    let counter = 1;
    while (document.querySelectorAll(`#${CSS.escape(uniqueId)}`).length > 1) {
      uniqueId = `${heading.id}-${counter}`;
      heading.id = uniqueId;
      counter++;
    }

    // Create TOC item
    const li = document.createElement('li');
    li.className = 'article-toc__item';

    const link = document.createElement('a');
    link.href = `#${heading.id}`;
    link.className = 'article-toc__link';
    link.textContent = heading.textContent;
    link.setAttribute('data-toc-link', heading.id);

    li.appendChild(link);
    tocItems.push({ element: li, headingId: heading.id });
  });

  // Inject TOC items into list
  tocItems.forEach(item => list.appendChild(item.element));

  // Mark TOC as initialized (makes it visible)
  toc.classList.add(CONFIG.classes.initialized);

  // Mobile accordion toggle
  if (toggle) {
    toggle.addEventListener('click', () => {
      const isExpanded = toc.classList.toggle(CONFIG.classes.expanded);
      toggle.setAttribute('aria-expanded', isExpanded);
    });
  }

  // Scroll spy with Intersection Observer
  let activeLink = null;

  const setActiveLink = (headingId) => {
    if (activeLink) {
      activeLink.classList.remove(CONFIG.classes.active);
    }

    const newActiveLink = list.querySelector(`[data-toc-link="${headingId}"]`);
    if (newActiveLink) {
      newActiveLink.classList.add(CONFIG.classes.active);
      activeLink = newActiveLink;
    }
  };

  // Track which headings are currently in view
  const visibleHeadings = new Set();

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const headingId = entry.target.id;

      if (entry.isIntersecting) {
        visibleHeadings.add(headingId);
      } else {
        visibleHeadings.delete(headingId);
      }
    });

    // Find the first visible heading (topmost in document order)
    if (visibleHeadings.size > 0) {
      for (const heading of headings) {
        if (visibleHeadings.has(heading.id)) {
          setActiveLink(heading.id);
          break;
        }
      }
    } else {
      // No headings in zone - find the last heading above viewport
      let lastAbove = null;
      for (const heading of headings) {
        if (heading.getBoundingClientRect().top < window.innerHeight * 0.3) {
          lastAbove = heading;
        }
      }
      if (lastAbove) {
        setActiveLink(lastAbove.id);
      }
    }
  }, CONFIG.observerOptions);

  // Observe all headings
  headings.forEach(heading => observer.observe(heading));

  // Smooth scroll to section on link click
  list.addEventListener('click', (e) => {
    const link = e.target.closest('.article-toc__link');
    if (!link) return;

    e.preventDefault();
    const targetId = link.getAttribute('href').slice(1);
    const targetHeading = document.getElementById(targetId);

    if (targetHeading) {
      const isMobile = window.innerWidth < 768;

      // Collapse mobile accordion FIRST, then scroll after layout settles
      if (isMobile) {
        toc.classList.remove(CONFIG.classes.expanded);
        if (toggle) toggle.setAttribute('aria-expanded', 'false');

        // Wait for accordion collapse transition before scrolling
        setTimeout(() => {
          const headerOffset = 20;
          const elementPosition = targetHeading.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });

          history.pushState(null, null, `#${targetId}`);
          targetHeading.setAttribute('tabindex', '-1');
          targetHeading.focus({ preventScroll: true });
        }, 350);
      } else {
        const headerOffset = 100;
        const elementPosition = targetHeading.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });

        history.pushState(null, null, `#${targetId}`);
        targetHeading.setAttribute('tabindex', '-1');
        targetHeading.focus({ preventScroll: true });
      }
    }
  });

  // Set initial active state based on scroll position (handles mid-page landing)
  const setInitialActive = () => {
    // If there's a hash, use that
    if (window.location.hash) {
      const targetId = window.location.hash.slice(1);
      setActiveLink(targetId);
      return;
    }
    // Otherwise find the last heading above viewport
    let lastAbove = null;
    for (const heading of headings) {
      if (heading.getBoundingClientRect().top < window.innerHeight * 0.3) {
        lastAbove = heading;
      }
    }
    if (lastAbove) {
      setActiveLink(lastAbove.id);
    }
  };

  // Run on load (slight delay for layout to settle)
  setTimeout(setInitialActive, 50);
})();
  } catch(e) { console.error(e); }
})();

})();
